// extracted by mini-css-extract-plugin
export default {"loading":"ContentRoute_loading__Ai0Jd"};